import React from "react";
import Countdown from "react-countdown";

const CountdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) return null;

  return (
    <div className="row g-2 mt-1">
      <div className="d-flex justify-content-center">
        <div className="main">🎊Sale ends in</div>
      </div>
      <div className="col-3">
        <div className="countdown-box d-flex flex-column justify-content-center align-items-center ">
          <div className="countdown-number" id="days">
            {String(days).padStart(2, "0")}
          </div>
          <div className="countdown-label">Days</div>
        </div>
      </div>
      <div className="col-3">
        <div className="countdown-box d-flex flex-column justify-content-center align-items-center ">
          <div className="countdown-number" id="hours">
            {String(hours).padStart(2, "0")}
          </div>
          <div className="countdown-label">Hours</div>
        </div>
      </div>
      <div className="col-3">
        <div className="countdown-box d-flex flex-column justify-content-center align-items-center ">
          <div className="countdown-number" id="minutes">
            {String(minutes).padStart(2, "0")}
          </div>
          <div className="countdown-label">Minutes</div>
        </div>
      </div>
      <div className="col-3">
        <div className="countdown-box d-flex flex-column justify-content-center align-items-center ">
          <div className="countdown-number" id="seconds">
            {String(seconds).padStart(2, "0")}
          </div>
          <div className="countdown-label">Seconds</div>
        </div>
      </div>
    </div>
  );
};

const CountdownTimer = ({ saleStartTime, setIsSaleStarted }) => {
  return (
    <Countdown
      date={saleStartTime}
      renderer={(props) => {
        if (props.completed) {
          setIsSaleStarted(true);
          return null;
        }
        return <CountdownRenderer {...props} />;
      }}
    />
  );
};

export default CountdownTimer;
